window.addEventListener('unhandledrejection', (event) => {
  const reason: unknown = event.reason;
  const stack =
    reason !== null && typeof reason === 'object' && 'stack' in reason
      ? String(reason.stack ?? '')
      : '';

  if (
    stack.includes('chrome-extension://') ||
    stack.includes('moz-extension://')
  ) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

function stripExtensionAttributes(element: Element | null): void {
  if (!element) return;

  for (const attribute of Array.from(element.attributes)) {
    if (
      attribute.name.startsWith('bis_') ||
      attribute.name.startsWith('__processed_')
    ) {
      element.removeAttribute(attribute.name);
    }
  }
}

stripExtensionAttributes(document.body);
document.querySelectorAll('[bis_skin_checked]').forEach(stripExtensionAttributes);
